<template>
  <b-modal
    :visible="value"
    :title="`Decision Committee - ${officeName || ''}`"
    centered
    size="lg"
    no-close-on-backdrop
    hide-footer
    @change="$emit('input', $event)"
  >
    <div
      v-if="loading"
      class="text-center my-2"
    >
      <b-spinner
        type="grow"
        label="Loading..."
      />
    </div>

    <div v-else>
      <b-table
        :items="items"
        :fields="fields"
        small
        bordered
        responsive
        show-empty
        empty-text="No committee members found"
      >
        <template #cell(active)="data">
          <b-badge :variant="data.item.active ? 'success' : 'secondary'">
            {{ data.item.active ? 'Active' : 'Inactive' }}
          </b-badge>
        </template>
      </b-table>

      <div class="d-flex justify-content-end mt-2">
        <b-btn
          variant="secondary"
          @click="$emit('input', false)"
        >
          Close
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'DecisionCommitteeViewModal',
  props: {
    value: {
      type: Boolean,
      default: () => false,
    },
    officeName: {
      type: String,
      default: () => '',
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
